import React from 'react';

import { constants } from '@nhl/formatter-utilities';

const HSBDateBlock = ({ date }) => (
    <div className={`hsb-date-block ${date}`}>
        <div className="date">{date.format(constants.HSB_DATE_FORMAT)}</div>
    </div>
);

export default HSBDateBlock;
